<template>
  <div class="flex flex-column align-items-center justify-content-start">
    <div class="button-card mb-2 flex flex-wrap justify-content-center"> <!-- <div class="flex gap-3 justify-content-center">
        <Button
          label="Preavvisi"
          @click="toggleComponent('Preavvisi')"
          class="custom-button"
        />
        <Button
          label="Solleciti"
          @click="toggleComponent('GestisciSolleciti')"
          class="custom-button"
        />
        <Button
          label="Sospensioni/Riattivazioni"
          @click="toggleComponent('PreviewSospensioniRiattivazioni')"
          class="custom-button"
        />
        <Button
          label="Fatture Scadute"
          @click="toggleComponent('FattureScadute')"
          class="custom-button"
        />
      </div> -->
      <div class="flex gap-3 justify-content-center" style="flex-wrap: nowrap;"> 
      <div class="m-3" v-for="voce in btn" :key="voce">
        <Button :label="voce.label" @click="toggleComponent(voce.component)"
          :class="`w-full btn-filter ${voce.selected ? 'selected' : ''}`" />
      </div>
    </div>
    </div>
    <div v-if="visibleComponent" class="component-card">
      <component :is="visibleComponent" class="component-container" />
    </div>
  </div>
</template>

<script>
import Preavvisi from '@/pages/PreavvisiInvio.vue';
import GestisciSolleciti from '@/pages/GestisciSolleciti.vue';
import FattureScadute from '@/pages/FattureScadute.vue';
import PreviewSospensioniRiattivazioni from '@/pages/PreviewSospensioniRiattivazioni.vue';
import PreviewRilascioTutela from '../../pages/PreviewRilascioTutela.vue';

export default {
  data() {
    return {
      visibleComponent: null,
      btn: [
        { label: 'Preavvisi', component: 'Preavvisi', selected: false },
        { label: 'Solleciti', component: 'GestisciSolleciti', selected: false },
        { label: 'Sospensioni/Riattivazioni', component: 'PreviewSospensioniRiattivazioni', selected: false },
        { label: 'Fatture Scadute', component: 'FattureScadute', selected: false },
        { label: 'Rilascio Tutela', component: 'PreviewRilascioTutela', selected: false },
      ]
    };
  },
  components: {
    Preavvisi,
    GestisciSolleciti,
    FattureScadute,
    PreviewSospensioniRiattivazioni,
    PreviewRilascioTutela
  },
  methods: {
    toggleComponent(component) {
      this.btn.forEach(voce => {
        voce.selected = voce.component == component
      })
      this.visibleComponent = this.visibleComponent === component ? null : component;
    },
  },
};
</script>
<style scoped>
.h-screen {
  height: 100vh; /* Imposta l'altezza della schermata intera */
  overflow: hidden; /* Rimuove le scrollbar */
}

.flex {
  display: flex; /* Abilita il flexbox */
}

.justify-content-start {
  justify-content: flex-start; /* Allinea gli elementi all'inizio */
}

.flex-wrap {
  flex-wrap: wrap; /* Permette di andare a capo */
}


.button-card {
  width: 100%; /* Larghezza massima */
  height: 30%; /* Altezza fissa per la card */
  background-color: #fff; /* Colore di sfondo */
  border-radius: 8px; 
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-top: 1px;
  display: flex; 
  flex-direction: column; 
  align-items: center;
  justify-content: center;
}

.component-card {
  width: 100%; 
  background-color: #fff; 
  border-radius: 8px; 
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-top: 20px;
}


.btn-filter {
  border-radius: 15px; 
  height: 95px; 
  width: 250px !important;
  background: var(--blue-800);
  padding: 10px; 
  font-size: 16px; 
  font-weight: bold;
  color: #fff; 
  text-align: center;
  cursor: pointer; 
  display: flex; 
  align-items: center;
  justify-content: center; 
  transition: background-color 0.3s ease; 
}

.btn-filter:hover {
  background-color: var(--blue-600); 
}

.m-3 {
  margin: 10px; 
}

</style>